<div [ngSwitch]="applicationFormField.controlType">


  <sd-form-field-textbox *ngSwitchCase="'textbox'" [formGroup]="form"
    [control]="form.controls[applicationFormField.key]" [formField]="applicationFormField"
    (onBlurEvent)=handleBlur($event)></sd-form-field-textbox>

  <sd-form-field-date *ngSwitchCase="'date'" [formGroup]="form" [control]="form.controls[applicationFormField.key]"
    [formField]="applicationFormField" (ondateSelectEvent)="dateSelectEvent($event)"></sd-form-field-date>

  <sd-form-field-dropdown *ngSwitchCase="'dropdown'" [formGroup]="form"
    [control]="form.controls[applicationFormField.key]" [formField]="applicationFormField"></sd-form-field-dropdown>

  <sd-form-field-radio *ngSwitchCase="'radio'" [formGroup]="form" [control]="form.controls[applicationFormField.key]"
    [formField]="applicationFormField"></sd-form-field-radio>

  <sd-form-field-textarea *ngSwitchCase="'textarea'" [formGroup]="form"
    [control]="form.controls[applicationFormField.key]" [formField]="applicationFormField"></sd-form-field-textarea>

</div>